export default __webpack_public_path__ + "static/ds_04-96452ceb12dfb32c1255579f5335b82e.png";